<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'GroupList'})"/>
                {{ $t('group.permissions.title', {name: this.group.name}) }}
              </h1>
            </div>
          </grid-col>
        </grid-row>
        <grid-row column-align="center">
          <grid-col col-size="2">
            <ul
              :id="listKey">
              <li
                v-for="assignablePermission in getAssignablePermissions()"
                v-bind:key="assignablePermission.name">
                <div
                  class="form-check"
                  @mouseover="onMouseOver(assignablePermission.name)"
                  @mouseleave="onMouseLeave">
                  <input
                    type="checkbox"
                    :id="assignablePermission.name"
                    :value="assignablePermission.name"
                    v-model="permission[assignablePermission.name]"
                    v-on:change="onPermissionChange()">
                  <label :for="assignablePermission.name">{{ $t(assignablePermission.label) }}</label>
                </div>
                <ul
                  v-if="assignablePermission.children !== undefined">
                  <li
                    v-for="assignableChildPermission in assignablePermission.children"
                    v-bind:key="assignableChildPermission.name">
                    <div
                      class="form-check"
                      @mouseover="onMouseOver(assignableChildPermission.name)"
                      @mouseleave="onMouseLeave">
                      <input
                        type="checkbox"
                        :id="assignableChildPermission.name"
                        :value="assignableChildPermission.name"
                        v-model="permission[assignableChildPermission.name]"
                        v-on:change="onPermissionChange()">
                      <label :for="assignableChildPermission.name">{{ $t(assignableChildPermission.label) }}</label>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </grid-col>
          <grid-col col-size="2">
            <div :class="screenshotClass"></div>
            <div v-html="permissionDescription"></div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import SimpleCheckbox from '../../components/shared/forms/SimpleCheckbox';
import Chevron from '@/components/shared/Chevron';
import config from 'BRAND/config';

export default {
  name: 'GroupPermissionList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    SimpleCheckbox,
    Chevron
  },
  data () {
    return {
      group: undefined,
      permission: {},
      screenshotClass: '',
      permissionDescription: '',
      listKey: 0
    };
  },
  watch: {
    getPermission: {
      handler: function () {
        this.getFlatAssignablePermissions().forEach(assignablePermission => {
          this.permission[assignablePermission.name] = this.getPermission[assignablePermission.name] !== undefined
            ? this.getPermission[assignablePermission.name]
            : false;
        });
        this.listKey += 1;
      }
    }
  },
  created () {
    this.group = this.$route.params;
    this.retrieveGroupPermissions({ context: this, groupId: this.group.id });
  },
  destroyed () {
    this.clearGroupPermission({ context: this });
  },
  computed: {
    ...mapGetters([
      'getPermission'
    ]),
    getBreadcrumb () {
      return [
        {
          link: '/settings',
          name: this.$t('menu.settings')
        },
        {
          link: '/group/list',
          name: this.$t('group.title')
        },
        {
          link: '/group/permission/list',
          name: this.$t('permission.permissions'),
          disabled: true
        }
      ];
    }
  },
  methods: {
    ...mapActions([
      'retrieveGroupPermissions',
      'updateGroupPermissions',
      'clearGroupPermission'
    ]),
    onPermissionChange () {
      if (event.target.value === 'process') {
        this.permission.levelsAndRhythms = this.permission.process;
        this.permission.masterLubricationPressure = this.permission.process;
      }
      if (event.target.value === 'levelsAndRhythms') {
        if (this.permission.levelsAndRhythms === true) {
          this.permission.process = true;
        } else if (this.permission.levelsAndRhythms === false && this.permission.masterLubricationPressure === false) {
          this.permission.process = false;
        }
      }
      if (event.target.value === 'masterLubricationPressure') {
        if (this.permission.masterLubricationPressure === true) {
          this.permission.process = true;
        } else if (this.permission.levelsAndRhythms === false && this.permission.masterLubricationPressure === false) {
          this.permission.process = false;
        }
      }
      if (event.target.value === 'explorer') {
        this.permission.query = this.permission.explorer;
      }
      if (event.target.value === 'query') {
        if (this.permission.query === true) {
          this.permission.explorer = true;
        }
      }
      if (event.target.value === 'rule') {
        if (this.permission.rule === false) {
          this.permission.repsolCurrentStatus = false;
        }
      }
      this.updateGroupPermissions({context: this, groupId: this.group.id, permission: this.permission});
      this.listKey += 1;
    },
    onMouseOver (clazz) {
      this.screenshotClass = clazz;
      this.permissionDescription = this.$t(descriptionTranslateKeys[clazz]);
    },
    onMouseLeave () {
      this.screenshotClass = '';
      this.permissionDescription = '';
    },
    getAssignablePermissions () {
      if (config.assignablePermissions !== undefined) {
        return config.assignablePermissions;
      }
      return [];
    },
    getFlatAssignablePermissions () {
      if (config.assignablePermissions !== undefined) {
        return this.flatten(config.assignablePermissions);
      }
      return [];
    },
    flatten (data) {
      return data.reduce((r, {children, ...rest}) => {
        r.push(rest);
        if (children) r.push(...this.flatten(children));
        return r;
      }, []);
    }
  }
};

/**
 * Match CSS background class with translation key.
 */
const descriptionTranslateKeys = {
  explorer: 'group.permissions.description.explorer',
  query: 'group.permissions.description.queries',
  rule: 'group.permissions.description.rules',
  aggregateVar: 'group.permissions.description.aggregateVariables',
  board: 'group.permissions.description.board',
  multiboard: 'group.permissions.description.multiboard',
  summary: 'group.permissions.description.summary',
  integration: 'group.permissions.description.integration',
  nutritionalPlan: 'group.permissions.description.nutritionalPlan',
  glucose: 'group.permissions.description.glucose'
};

</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.explorer {
  content: url($brandImage-screenshot-explorer);
  background-repeat: no-repeat;
}

.query {
  content: url($brandImage-screenshot-queries);
  background-repeat: no-repeat;
}

.taxonomy {
  content: url($brandImage-screenshot-taxonomy);
  background-repeat: no-repeat;
}

.rule {
  content: url($brandImage-screenshot-rules-and-events);
  background-repeat: no-repeat;
}

.aggregateVariable {
  content: url($brandImage-screenshot-aggregate-variables);
  background-repeat: no-repeat;
}

.board {
  content: url($brandImage-screenshot-board);
  background-repeat: no-repeat;
}

.multiboard {
  content: url($brandImage-screenshot-multiboard);
  background-repeat: no-repeat;
}

.summary {
  content: url($brandImage-screenshot-summary);
  background-repeat: no-repeat;
}

.integration {
  content: url($brandImage-screenshot-integration);
  background-repeat: no-repeat;
}
.nutritionalPlan {
  content: url($brandImage-screenshot-nutritional-plan);
  background-repeat: no-repeat;
}

.glucose {
  content: url($brandImage-screenshot-glucose);
  background-repeat: no-repeat;
}

li {
  list-style-type: none;
  font-size: $fs-l;
  font-weight: 200;
  line-height: $lh-h;
  margin-bottom: 1em;
  margin-top: 1em;
}

.form-check {
  margin-bottom: $sp-margin-small;
  width: fit-content;
}

[type="checkbox"]:not(:checked),
[type="checkbox"]:checked {
  position: absolute;
  left: -9999px;
}
[type="checkbox"]:not(:checked) + label,
[type="checkbox"]:checked + label {
  position: relative;
  padding-left: $height1 + $sp-margin-smaller;
  cursor: pointer;
}

[type="checkbox"]:not(:checked) + label:before,
[type="checkbox"]:checked + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: -2px;
  width: $height1;
  height: $height1;
  border: 2px solid $black-light2;
  background: $white;
  border-radius: 3px;
}
[type="checkbox"]:checked + label:before {
  border-color: transparent;
}
[type="checkbox"]:not(:checked) + label:after,
[type="checkbox"]:checked + label:after {
  content: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPHRpdGxlPkNoZWNrYm94PC90aXRsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+Cjxwb2x5Z29uIGlkPSJwYXRoLTNfMV8iIGNsYXNzPSJzdDAiIHBvaW50cz0iNy4zLDE1LjkgMywxMS42IDQuNSwxMC4xIDcuMiwxMi44IDE1LjIsNCAxNi44LDUuNSAiLz4KPC9zdmc+Cg==");
  position: absolute;
  top: -2px;
  left: 0;
  width: $height1;
  height: $height1;
  transition: all 0.2s;
  border-radius: 3px;
  background-color: $active;
}
[type="checkbox"]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}
[type="checkbox"]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}
[type="checkbox"]:disabled:checked + label:after {
  color: #999;
}
[type="checkbox"]:disabled + label {
  color: #aaa;
}
[type="checkbox"]:checked:focus + label:before,
[type="checkbox"]:not(:checked):focus + label:before {
  outline: $link-dark solid 2px;
  outline-offset: 2px;
}
[checkbox-inverse] label {
  color: $white;
}
label:hover {
  color: $black-trans2;
}
[checkbox-inverse] label:hover {
  color: $white-trans4;
}

.form-check[disabled] {
  opacity: 0.25;
  pointer-events: none;
}

@mixin check-size($font-size, $height, $correction) {
  .form-check,
  &.form-check {
    font-size: $font-size;
  }
  [type="checkbox"]:not(:checked) + label,
  [type="checkbox"]:checked + label {
    padding-left: $height + $sp-margin-smaller;
  }
  [type="checkbox"]:not(:checked) + label:before,
  [type="checkbox"]:checked + label:before,
  [type="checkbox"]:not(:checked) + label:after,
  [type="checkbox"]:checked + label:after {
    top: $correction;
    width: $height;
    height: $height;
  }
}
[check-size="xs"] {
  @include check-size($fs-xs, $height00, 0);
}
[check-size="s"] {
  @include check-size($fs-s, $height0, -1px);
}
[check-size="m"] {
  @include check-size($fs, $height1, -2px);
}
[check-size="l"] {
  @include check-size($fs-l, $height2, -3px);
}
</style>



// WEBPACK FOOTER //
// src/layouts/groups/GroupPermissionList.vue